"use client";

import React from "react";

import { cn } from "utils";

export interface ScoreRingBadgeProps {
  /** 当前分数 */
  value: number;
  /** 满分，默认 100 */
  max?: number;
  /** 分数下方文案 */
  label?: string;
  className?: string;
  ringClassName?: string;
  valueClassName?: string;
  labelClassName?: string;
}

/**
 * 通用圆环分数组件（ring-progress），用于卡片内 score 展示。
 */
export const ScoreRingBadge: React.FC<ScoreRingBadgeProps> = ({
  value,
  max = 100,
  label,
  className,
  ringClassName,
  valueClassName,
  labelClassName,
}) => {
  const percent = Math.min(100, Math.max(0, max > 0 ? (value / max) * 100 : 0));
  const ringStyle = {
    "--ring-percent": percent,
  } as React.CSSProperties;

  return (
    <div className={cn("flex shrink-0 flex-col items-center", className)}>
      <span
        style={ringStyle}
        className={cn(
          "title_l text-content_brand_primary ring-progress rp-w-0.5 rp-b-transparent rp-a-content_aura_lv1_primary flex size-8.5 items-center justify-center",
          ringClassName,
        )}
      >
        <span className={cn("relative z-[1]", valueClassName)}>{value}</span>
      </span>
      {label ? (
        <span className={cn("body_xs text-content_quaternary", labelClassName)}>
          {label}
        </span>
      ) : null}
    </div>
  );
};
